<template>
  <div>
    <Content />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Content from '@/components/Login.vue'; // @ is an alias to /src

@Component({
  components: {
    Content,
  },
})
export default class Login extends Vue {}
</script>
